import { sortParamToQuery, filterValueToQuery } from '@/api';

const registrationTypeList = [
  'GOVERNMENT',
  'ENTREPRENEUR',
  'REGULATOR',
  'FUND_MANAGERS_AND_INVESTOR',
  'CIVIC_ORGANIZATION',
  'PARTNER_SPONSOR',
  'PRESS_MEDIA',
  'INFLUENCER_KOL',
  'INDIVIDUAL',
  'STUDENT',
  'OTHER',
];

const registrationTypeDisplay = [
  'หน่วยงานภาครัฐ',
  'ผู้ประกอบการ / หน่วยงานเอกชน',
  'หน่วยงานกำกับดูแล',
  'นักลงทุนสถาบัน',
  'ภาคประชาสังคมและการศึกษา',
  'พันธมิตร / หุ้นส่วน / ผู้สนับสนุน',
  'สื่อมวลชน',
  'Influencer / KOL',
  'บุคคลทั่วไป',
  'นักเรียน / นักศึกษา',
  'อื่น ๆ โปรดระบุ...',
];

function translate(type: string) {
  const index = registrationTypeList.indexOf(type);
  if (index > -1) return registrationTypeDisplay[index];
  return '-';
}

export default function user(axios: any) {
  const register = async (
    name: string,
    email: string,
    telephone: string,
    organization: string,
    isPress: boolean,
    online: boolean,
    registrationType: string,
    pin: string | undefined,
    payment_status: boolean | undefined,
    other_registration_type = '',
    admin = undefined,
    employeeCode = '',
    pdpaConsent = false,
  ) => {
    try {
      const response = await axios.post('admin/register', {
        name,
        email,
        telephone,
        organization,
        // eslint-disable-next-line
        is_press: isPress,
        online,
        admin,
        employeeCode: employeeCode !== '' ? employeeCode : undefined,
        // eslint-disable-next-line
        registration_type: registrationType,
        // eslint-disable-next-line
        pdpa_consent: pdpaConsent,
        pin: pin !== '' ? pin : undefined,
        // eslint-disable-next-line
        payment_status,
        // eslint-disable-next-line
        other_registration_type,
      });
      if (response.status === 200) return response.data;
    } catch (err: any) {
      console.log('[api/user.ts] register error');
      if (err.message === 'There is already a user with this pin.') return { status: 422 };
    }
    return { status: 1 };
  };

  /* VISITOR API */
  async function getVisitors(filter: any) {
    try {
      const response = await axios.get(`/users?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response;
      }
    } catch (e) {
      console.error('[api/user] getVisitors error', e);
    }
    return { data: [], total: 0 };
  }

  const getVisitor = async (
    id: number,
  ) => {
    const result = await axios.get(`/users/${id}`).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const getVisitorPin = async (
    id: number,
  ) => {
    const result = await axios.post(`/users/${id}/resetPin`).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const updateVisitor = async (
    id: number,
    name: string,
    email: string,
    telephone: string,
    organization: string,
    // eslint-disable-next-line
    registration_type: string,
    pin: string | undefined,
    payment_status: boolean | undefined,
    online: boolean | undefined,
    other_register_type = '',
    admin = false,
    employeeCode = '',
  ) => {
    const result = await axios.put(`/users/${id}/edit`, {
      name,
      email,
      telephone,
      organization,
      // eslint-disable-next-line
      registration_type,
      admin,
      employeeCode: employeeCode !== '' ? employeeCode : undefined,
      pin: pin !== '' ? pin : undefined,
      payment_status,
      online,
      // eslint-disable-next-line
      other_register_type,
    }).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const activateVisitor = async (
    id: number,
    active: boolean,
  ) => {
    const result = await axios.post(`/users/${id}/edit`, {
      active,
    }).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const sendConfirmRegisterEmailToVisitor = async (
    id: number | string,
  ) => {
    const response = await axios.post(`/users/${id}/sendRegisterEmail`);

    try {
      if (response.status === 200) {
        return true;
      }
    } catch (e) {
      return false;
    }
    return false;
  };

  const deleteVisitor = async (
    id: number,
  ) => {
    const result = await axios.post('/users/delete', {
      ids: [id],
    }).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const deleteVisitors = async (
    ids: number[],
  ) => {
    const result = await axios.post('/users/delete', {
      ids,
    }).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const forceLogout = async (id: number) => {
    const response = await axios.post(`/users/${id}/forceLogout`);
    try {
      if (response.status === 200) {
        return response.data.success;
      }
    } catch (e) {
      console.log('[api/user.ts] forceLogout error');
    }
    return 'error';
  };

  return {
    register,
    getVisitors,
    getVisitor,
    getVisitorPin,
    updateVisitor,
    activateVisitor,
    sendConfirmRegisterEmailToVisitor,
    deleteVisitor,
    deleteVisitors,
    forceLogout,

    registrationTypeList,
    registrationTypeDisplay,
    visitorTypeTranslate: translate,
  };
}
